import { useState } from "react";
import Layout5 from "./Layout5";
import Layout6 from "./Layout6";
import LayoutWithIcons from "./LayoutWithIcons";
import { Grid, Pagination } from "@mui/material";
import Layout11 from "./Layout11";
import Layout12 from "./Layout12";
import Layout15 from "./Layout15";
import Layout17 from "./Layout17";
import Layout9 from "./Layout9";
import Layout18 from "./Layout18";
import Layout19 from "./Layout19";
import Layout20 from "./Layout20";

interface Question {
  updatedBy: string;
  question: string;
  mediaUrl: string;
  difficultyLevel: string;
  answerType: number;
  active: boolean;
  marks: number;
  updatedDate: string;
  subjectId: number;
  questionBankId: number;
  classId: number;
  createdDate: string;
  createdBy: string;
  optionsList: any[];
  questionPaperId: number;
  uiType: number;
  remarks: string;
}

interface LayoutProps {
  Questions: Question[];
  sectionName: string;
}

const GrammarSectionLayout: React.FC<LayoutProps> = ({
  Questions,
  sectionName,
}) => {
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);

  const handleNavigate = (direction: "previous" | "next") => {
    if (direction === "previous") {
      setCurrentQuestionIndex((prevIndex) => Math.max(prevIndex - 1, 0));
    } else if (direction === "next") {
      setCurrentQuestionIndex((prevIndex) =>
        Math.min(prevIndex + 1, Questions.length - 1)
      );
    }
  };

  const handlePaginationChange = (
    event: React.ChangeEvent<unknown>,
    value: number
  ) => {
    setCurrentQuestionIndex(value - 1);
  };

  const currentQuestion = Questions[currentQuestionIndex];

  const getLayoutComponent = () => {
    const layout18Questions = Questions.filter(
      (question) => question.uiType === 18
    );
    const layout5Questions = Questions.filter(
      (question) => question.uiType === 5
    );
    const layout6Questions = Questions.filter(
      (question) => question.uiType === 6
    );
    const layout9Questions = Questions.filter(
      (question) => question.uiType === 9
    );
    const layout11Questions = Questions.filter(
      (question) => question.uiType === 11
    );
    const layout12Questions = Questions.filter(
      (question) => question.uiType === 12
    );
    const layout17Questions = Questions.filter(
      (question) => question.uiType === 17
    );
    const layout15Questions = Questions.filter(
      (question) => question.uiType === 15
    );
    const layout19Questions = Questions.filter(
      (question) => question.uiType === 19
    );
    const layout20Questions = Questions.filter(
      (question) => question.uiType === 20
    );

    const layout11length = layout11Questions.length;
    console.log("layout5QuestionsLength", layout11length);

    // if (currentQuestion.uiType === 5) {
    //   return (
    //     <Layout5
    //       Questions={layout5Questions}
    //       currentQuestionIndex={currentQuestionIndex}
    //       setCurrentQuestionIndex={setCurrentQuestionIndex}
    //     />
    //   );
    // } else if (currentQuestion.uiType === 6) {
    //   return (
    //     <Layout6
    //       Questions={layout6Questions}
    //       currentQuestionIndex={currentQuestionIndex}
    //       setCurrentQuestionIndex={setCurrentQuestionIndex}
    //       layout5length={layout5length}
    //     />
    //   );
    // }

    // Find the index of current question within the filtered array
    const getFilteredIndex = (filteredQuestions: Question[]) => {
      const currentQuestionBankId = currentQuestion.questionBankId;
      return filteredQuestions.findIndex(
        (q) => q.questionBankId === currentQuestionBankId
      );
    };

    switch (currentQuestion.uiType) {
      case 11: // layouts with textFields
        return (
          <Layout11
            Questions={layout11Questions}
            currentQuestionIndex={getFilteredIndex(layout11Questions)}
            setCurrentQuestionIndex={setCurrentQuestionIndex}
            sectionName={sectionName}
          />
        );
      case 12: // drag and drop to "a" and "an" box
        return (
          <Layout12
            Questions={layout12Questions}
            currentQuestionIndex={getFilteredIndex(layout12Questions)}
            setCurrentQuestionIndex={setCurrentQuestionIndex}
            layout11length={layout11length}
            sectionName={sectionName}
          />
        );
      case 17: // layouts with textFields
        return (
          <Layout17
            Questions={layout17Questions}
            currentQuestionIndex={getFilteredIndex(layout17Questions)}
            sectionName={sectionName}
          />
        );
      case 9:
        return (
          <Layout9
            Questions={layout9Questions}
            sectionName={sectionName}
            currentQuestionIndexProp={getFilteredIndex(layout9Questions)}
            isGrammarLayout={true}
          />
        );
      case 18: // Layout18 - Simplified layout with FAB
        return (
          <Layout18
            Questions={layout18Questions}
            sectionName={sectionName}
            currentQuestionIndexProp={getFilteredIndex(layout18Questions)}
          />
        );
      case 19: // Layout19 - Clickable sentence options with color themes
        return (
          <Layout19
            Questions={layout19Questions}
            sectionName={sectionName}
            currentQuestionIndexProp={getFilteredIndex(layout19Questions)}
          />
        );
      case 20:
        return (
          <Layout20
            Questions={layout20Questions}
            sectionName={sectionName}
            currentQuestionIndexProp={getFilteredIndex(layout20Questions)}
          />
        );
      // case 15: // how many can you think of
      //   return (
      //     <>
      //       <Layout15
      //         Questions={layout15Questions}
      //         currentQuestionIndex={currentQuestionIndex}
      //         setCurrentQuestionIndex={setCurrentQuestionIndex}
      //       />
      //     </>
      //   );
      default: // Default case, if uiType doesn't match any of the above cases
        return (
          <>
            <p>Question doesn't have appropriate Ui Type value</p>
          </>
        );
    }
  };
  return (
    <div>
      <LayoutWithIcons onNavigate={handleNavigate}>
        {getLayoutComponent()}
        <Grid container lg={12} md={12} sm={12} xs={12} justifyContent="center">
          <Pagination
            count={Questions.length}
            shape="rounded"
            sx={{
              marginBottom: "1vh",
              paddingTop: "4%",
            }}
            page={currentQuestionIndex + 1}
            onChange={handlePaginationChange}
          />
        </Grid>
      </LayoutWithIcons>
    </div>
  );
};
export default GrammarSectionLayout;
